module.exports = __webpack_public_path__ + "static/img/13areaB_7.27bb0c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/13areaB_7.png
// module id = 1123
// module chunks = 1